import React from "react";
import ReusableForm from "../../../common/ReusableForm";

import { Typography } from "@mui/material";

const ModalFormInstitute = ({
  handleSubmit,
  handleInputChange,
  data,
  formError,
  type,
  isApiLoading,
  handleCloseModal,
  isDisabled,
}) => {
  const fields = [
    {
      label: "Institute Name",
      name: "instituteName",
      id: "instituteName",
      type: "text",
      required: true,
      errorKey: "InstituteName",
    },
    {
      label: "Institute Type",
      name: "instituteType",
      id: "instituteType",
      type: "text",
      required: true,
      errorKey: "InstituteType",
    },
    {
      label: "Phone",
      name: "phone",
      id: "phone",
      type: "phone",
      errorKey: "phone",
    },
    {
      label: "Email",
      name: "email",
      id: "Email",
      type: "email",
      required: true,
      errorKey: "email",
      isDisabled: type !== "add" ? true : false,
    },
  ];

  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ marginBottom: 2 }}>
        {type === "add" ? " Create New Institute" : "Edit Institute"}
      </Typography>
      <ReusableForm
        fields={fields}
        handleChange={handleInputChange}
        handleSubmit={handleSubmit}
        errors={formError}
        formData={data}
        isApiLoading={isApiLoading}
        handleCloseModal={handleCloseModal}
        isDisabled={isDisabled}
        type={type}
      />
    </>
  );
};

export default ModalFormInstitute;
